module.exports = __webpack_public_path__ + "static/media/Lion Face981_2c.05e0f7cd.svg";